import { render } from "./SplitButton.vue?vue&type=template&id=31965c7f&scoped=true"
import script from "./SplitButton.vue?vue&type=script&lang=js"
export * from "./SplitButton.vue?vue&type=script&lang=js"

import "./SplitButton.vue?vue&type=style&index=0&id=31965c7f&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31965c7f"]])

export default __exports__